import { api } from './api';
import { fetchResource, updateResource } from './fetchResource';

export function fetchSocialSecurityModule() {
  return dispatch => fetchResource(dispatch, 'modules/social_security', 'SOCIAL_SECURITY_MODULE_FETCHED');
}

export function updateSocialSecurityModule(payload) {
  return dispatch => updateResource(dispatch, 'modules/social_security', payload, 'SOCIAL_SECURITY_MODULE_FETCHED');
}

export function changeSocialSecurityStage(stage) {
  return dispatch => {
    return api.put('/api/modules/social_security', { stage }).then(response => {
      dispatch({ type: 'SOCIAL_SECURITY_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function updateSocialSecurityData(data) {
  return dispatch => {
    return api.put('/api/modules/social_security', data).then(response => {
      dispatch({ type: 'SOCIAL_SECURITY_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function optimizeSocialSecurityPlan() {
  return dispatch => {
    return api.post('/api/modules/social_security/optimize').then(response => {
      dispatch({ type: 'SOCIAL_SECURITY_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function fetchSocialSecurityLifetimeEstimates({ holder, lifespan }) {
  return dispatch => {
    return api
      .get(`/api/modules/social_security/lifetime_estimates?holder=${holder}&lifespan=${lifespan}`)
      .then(response => {
        dispatch({
          type: 'SOCIAL_SECURITY_LIFETIME_ESTIMATES_FETCHED',
          holder: holder,
          payload: response.data,
        });
      });
  };
}

export function fetchSocialSecurityBenefitEstimates() {
  return dispatch => {
    return api.get(`/api/modules/social_security/benefit_estimates`).then(response => {
      dispatch({
        type: 'SOCIAL_SECURITY_BENEFIT_ESTIMATES_FETCHED',
        payload: response.data,
      });
    });
  };
}

export function fetchSocialSecurityOptimalAges({ primaryLifespan, partnerLifespan } = {}) {
  return dispatch => {
    return api
      .get(
        `/api/modules/social_security/optimal_social_security_ages?primary_lifespan=${primaryLifespan}&partner_lifespan=${partnerLifespan}`
      )
      .then(response => {
        dispatch({
          type: 'SOCIAL_SECURITY_OPTIMAL_AGES_FETCHED',
          payload: response.data,
        });
      });
  };
}

export function displayPlanImpactSocialSecurity() {
  return { type: 'SOCIAL_SECURITY_PLAN_IMPACT_SHOULD_BE_DISPLAYED' };
}
